import i18n from '@/i18n';

export default [
  {
    path: '/reports/daily',
    name: 'daily-reports-cpc',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'cpc-reports',
          actions: ['view'],
        },
      ],
      title: i18n.global.t('daily_cpc_reports')
    },
    // route level code-splitting
    component: () => import('../../views/reports/Daily'),
  },
  {
    path: '/reports/daily/advanced',
    name: 'advanced-daily-reports-cpc',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'cpc-reports-advanced',
          actions: ['view'],
        },
      ],
      title: i18n.global.t('advanced_daily_reports')
    },
    // route level code-splitting
    component: () => import('../../views/reports/DailyAdvanced'),
  },
  {
    path: '/reports/daily-cpm',
    name: 'daily-reports-cpm',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'cpm-reports',
          actions: ['view'],
        },
      ],
      title: i18n.global.t('daily_cpm_reports')
    },
    // route level code-splitting
    component: () => import('../../views/reports/DailyCPM'),
  },

  {
    path: '/reports',
    name: 'reports',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'performance-reports',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('reports')
    },
    // route level code-splitting
    component: () => import('../../views/reports/Index'),
  },
  {
    path: '/reports/:id(\\d+)',
    name: 'reports-details',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'performance-reports',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('report_details')
    },
    // route level code-splitting
    component: () => import('../../views/reports/Single'),
  },
];
